<template>
    <div>
        <div class="p-2 font-bold">{{ title }}</div>
        <div v-if="isFetching && !isFetchingNextPage">
            <div class="text-grey-400 px-3 py-2 text-sm font-light">
                <UiIcon name="refresh" class="mr-2 inline-block h-4 w-4 animate-spin" />
                Suche nach <span class="text-grey-600 italic">{{ query }}</span>
            </div>
        </div>
        <div v-else>
            <div v-if="options.length">
                <ul>
                    <li
                        v-for="(option, index) in options"
                        :key="option.id"
                        @click="selectOption(option)"
                        @mouseover="handleHover(index)"
                        class="header_search-option"
                        :class="{ 'ui-active': index + indexOffset === activeIndex }">
                        <slot :option="option"> </slot>
                    </li>
                </ul>
            </div>
            <div v-if="!options.length && !isFetching" class="text-grey-400 px-3 py-2 align-baseline text-sm font-light">
                <UiIcon name="ban" class="mr-2 inline-block h-4 w-4" />
                Keine Vorschläge für <span class="text-grey-600 italic">{{ query }}</span>
            </div>
        </div>
        <div v-if="hasNextPage || isFetchingNextPage" class="mx-3 flex justify-center border-b py-2">
            <button @click="fetchNextPage" :disabled="isFetchingNextPage" class="form-button button-xs">
                <span v-if="isFetchingNextPage">Weitere werden geladen</span>
                <span v-else class="flex items-center gap-x-1">
                    <UiIcon name="plus" class="h-3 w-3" />
                    Weitere laden
                </span>
            </button>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import { type PropType } from 'vue'

    const props = defineProps({
        title: String,
        options: Array as PropType<Array<any>>,
        isFetching: Boolean,
        hasNextPage: Boolean,
        fetchNextPage: Function as PropType<() => void>,
        query: String,
        isFetchingNextPage: Boolean,
        activeIndex: Number,
        indexOffset: Number
    })

    const emit = defineEmits(['select', 'hover'])

    function selectOption(option: any) {
        emit('select', option)
    }

    function handleHover(index: number) {
        emit('hover', index + props.indexOffset)
    }
</script>

<style scoped>
    .header_search-option {
        @apply text-grey-800 ui-active:bg-gray-50 cursor-default select-none py-2 pl-3 pr-9;
    }
    .ui-active {
        @apply bg-gray-50;
    }
</style>
